// src/services/siteVisits.js
const API_BASE = `${import.meta.env.VITE_API_URL || 'https://new.sbdemolition.online'}/api/site-visits`;

async function apiRequest(endpoint, options = {}) {
  const authToken = localStorage.getItem('authToken');
  
  const headers = {
    'Content-Type': 'application/json',
    ...(authToken && { 'Authorization': `Bearer ${authToken}` }),
    ...options.headers
  };

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers
  });

  if (response.status === 401) {
    localStorage.clear();
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }

  const text = await response.text();
  
  if (text.trim().startsWith('<!DOCTYPE') || text.trim().startsWith('<html')) {
    return { success: false, error: 'Server error', data: null };
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    throw new Error('Invalid JSON response');
  }
}

export const siteVisitsAPI = {
  get: (projectId) => apiRequest(`/get.php?project_id=${projectId}`),
  
  save: (projectId, data) => apiRequest('/save.php', {
    method: 'POST',
    body: JSON.stringify({
      project_id: projectId,
      ...data
    })
  })
};
